export default "__VITE_ASSET__Qveyxb0X__"